import { render, staticRenderFns } from "./AxUser.vue?vue&type=template&id=aae14282&scoped=true&"
import script from "./AxUser.vue?vue&type=script&lang=ts&"
export * from "./AxUser.vue?vue&type=script&lang=ts&"
import style0 from "./AxUser.vue?vue&type=style&index=0&id=aae14282&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae14282",
  null
  
)

export default component.exports